<!--
 * @Description: ^_^
 * @Author: sharebravery
 * @Date: 2022-05-07 09:19:50
 * @LastEditors: luckymiaow
 * @LastEditTime: 2023-06-20 09:39:10
-->

<script lang="ts" setup>
import { computed, ref, useAttrs, watch } from 'vue';
import useForm from '../../form/src/useFormConfig';
import { SelectPaged } from '../../select-paged';
import type { ISelectProps } from '../types';
import SelectBasic from './_SelectBasic.vue';
import SelectApi from './_SelectApi.vue';

interface Props extends ISelectProps {
  nullValue?: any; // 指定数据为null
}

const props = withDefaults(defineProps<Props>(), {});

const { getBindValue } = useForm<any>({ props: null, componentName: 'Select', attrs: useAttrs() });

const value = ref();

watch(
  () => getBindValue.value.value,
  () => {
    if (props.nullValue === getBindValue.value.value) {
      value.value = undefined;
    } else {
      value.value = getBindValue.value.value;
    }
  },
  { immediate: true }
);

const isPaged = computed(() => {
  if (getBindValue.value?.params) {
    return 'limit' in getBindValue.value?.params && 'offset' in getBindValue.value?.params;
  }
  return false;
});
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<template>
  <template v-if="'api' in getBindValue">
    <SelectPaged v-if="isPaged" v-bind="getBindValue" v-model:value="value">
      <template v-for="item in Object.keys($slots)" #[item]="data">
        <slot :name="item" v-bind="data || {}"></slot>
      </template>
    </SelectPaged>

    <SelectApi v-else v-bind="getBindValue" v-model:value="value">
      <template v-for="item in Object.keys($slots)" #[item]="data">
        <slot :name="item" v-bind="data || {}"></slot>
      </template>
    </SelectApi>
  </template>

  <SelectBasic v-else v-bind="getBindValue" v-model:value="value">
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </SelectBasic>
</template>
